import Icon from 'components/Icon'
import classNames from 'classnames'
import { useState } from 'react'
import { stopPropagation } from 'utils'
import SortIcon from 'components/table/SortIcon'
import useSortMenu from 'components/table/useSortMenu'
import NoneAnchor from 'components/NoneAnchor'
import { ColumnSorts } from '../../features/Columns'

const SortMenu = ({ sortMenu }) => {
  const [isOpened, setOpened] = useState(false)
  const { menu, activate, activeItem, toggleOrder } = sortMenu

  return (
    <>
      <NoneAnchor className="desc_sort">
        {(ColumnSorts[activeItem.name] || {}).title}
        <Icon
          name="sort"
          className={classNames('ico_comm', {
            sort_up: activeItem.order === 'asc',
            sort_down: activeItem.order === 'desc',
          })}>
          정렬
        </Icon>
      </NoneAnchor>

      <span
        onMouseEnter={() => setOpened(true)}
        onMouseLeave={() => setOpened(false)}
        style={{ pointerEvents: 'auto' }}>
        <NoneAnchor className="btn_menu">
          <Icon name="menu">펼침/닫힘</Icon>
        </NoneAnchor>

        {isOpened && (
          <span className="menu_layer">
            {menu.map(item => (
              <NoneAnchor
                key={item.name}
                className={classNames('link_menu', {
                  on: item.name === activeItem.name,
                })}
                onClick={stopPropagation(() =>
                  item.name === activeItem.name
                    ? toggleOrder(item)
                    : activate(item)
                )}>
                {ColumnSorts[item.name].title}
                <SortIcon sortItem={item} />
              </NoneAnchor>
            ))}
          </span>
        )}
      </span>
    </>
  )
}

export default SortMenu

SortMenu.propTypes = {
  sortMenu: useSortMenu.PropType.isRequired,
}
